module.exports = __webpack_public_path__ + "img/clockin-1.13f1d962.jpg";